
import { useState, useEffect, useContext, createContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { SubjectSelector, ProgramSelector, FeatureTypeSelector } from "@Beasted1010/pivotal-wisdom";
import { fetchUpdateUserProgress } from "../utilities/server-update";

import { useProgram, useProgramUpdate } from "./ProgramContext";
import { useUser } from "./UserContext";
import { reportProgress } from "../utilities/server-update-analytics";


export {
  LessonsContextProvider,
  useLessons, useLessonsUpdate
};


const LessonsContext = createContext<any>( null ); // TODO: Properly fill out
const LessonsUpdateContext = createContext<any>( null );


function useLessons() {
  return useContext( LessonsContext );
}

function useLessonsUpdate() {
  return useContext( LessonsUpdateContext );
}






type LessonsContextProps = {
  children?: JSX.Element | JSX.Element[];

  lessons: ILesson[];
}


function LessonsContextProvider( {lessons, children}: LessonsContextProps ) {
  // Provider handles...

  // ... Creating State
  const [lessonsData, setLessonsData] = useState<ILesson[]>( [] );
  const [selectedLesson, setSelectedLesson] = useState<ILesson | null>( null );

  const [ lessonToCompletedMap, setLessonToCompletedMap ] = useState<any[]>( [] ); // TODO: TYPE


  const { selectedSubject, selectedProgram, selectedFeature, selectedFeatureProgress } = useProgram();
  const { updateUserProgressForFeature } = useProgramUpdate();

  const { user } = useUser();



  // ... Updating State
  useEffect( () => {
    const lessonToCompletedMap = lessons?.map( (lesson, index) => {
      const lessonComplete = selectedFeatureProgress?.some( (lessonProgress: any) => { // TODO: TYPE
        return lessonProgress.number === index + 1 && lessonProgress.complete;
      });

      return lessonComplete;
    });
    setLessonToCompletedMap( lessonToCompletedMap );
  }, [lessons, selectedFeatureProgress]);

  useEffect( () => {
    if( lessons == null ) return; // TODO Better Error Handling ??

    setLessonsData( lessons );

    // TODO: FIXes DeepDives and Course having dif Lessons Count and switching between stores lesson
    setSelectedLesson( lessons[0] ); //setSelectedLesson(lessons[lessonNumber]);
  }, [lessons]);


  function selectLesson( lessonNumber: number ) {
    if( lessonNumber == null || lessons == null ) return; // TODO Better Error Handling ??

    // NOTE: Lesson Number is 1 based. Using that to index Array, so 0-base it
    const lessonIndex = lessonNumber - 1;

    setLessonsData( lessons );
    setSelectedLesson( lessons[lessonIndex] );
  }

  const toggleLessonComplete = useCallback( async ( lessonNumber: number ) => {
    // TODO: Need to update SERVER, BUT, if use NoSQL, may require hefty UPDATE Operation

    if( lessonNumber == null ) return;

    const lessonIndex = lessonNumber - 1;
    if( lessonIndex < 0 || lessonIndex >= lessons.length ) return null;


    lessonToCompletedMap[ lessonIndex ] = !lessonToCompletedMap[ lessonIndex ];

    const userProgress = {
      subjectSelector: selectedSubject,
      programSelector: selectedProgram,
      featureSelector: selectedFeature,

      userProgressType: "lessonCompletion", // ProgressEventType.LESSON_COMPLETION, // TODO: Use once moved to Shared Library
      data: {
        lessonNumber: lessonNumber,
        //isComplete: updatedLessonsProgress[lessonProgressIndex].complete,
        isComplete: lessonToCompletedMap[lessonIndex],
      }
    };

    if( user ) {
      //await fetchUpdateUserProgress( userProgress );
      await updateUserProgressForFeature( userProgress, selectedFeature );
    }


    setLessonToCompletedMap( [...lessonToCompletedMap] );

    reportProgress({
      progressType: "lessonCompletion", // ProgressEventType.LESSON_COMPLETION, // TODO: Use once moved to Shared Library
      progressDetails: { lessonId: lessonNumber, isCompleted: lessonToCompletedMap[lessonIndex] },

      subjectSelector: selectedSubject,
      programSelector: selectedProgram,
      featureSelector: selectedFeature
    });

  }, [lessonToCompletedMap] );



  // ... Persisting State down into Children
  return (
    <LessonsContext.Provider value={ {lessonsData, selectedLesson, lessonToCompletedMap} } >
      <LessonsUpdateContext.Provider value={ {selectLesson, toggleLessonComplete} } >
        {children}
      </LessonsUpdateContext.Provider>
    </LessonsContext.Provider>
  )
}


// ================================= HELPERS =================================
/*function featureContainsLessons( selectedFeature: FeatureTypeSelector ) {
  return (
    selectedFeature === FeatureTypeSelector.COURSE ||
    selectedFeature === FeatureTypeSelector.DEEP_DIVES
  );
}*/





/**/
